var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("boleto / "+_vm._s(_vm.$route.params.id === 'Contas' ? 'Parcelamento de Contas' : 'Parcelamento Débitos Detran'))])])}
var staticRenderFns = []

export { render, staticRenderFns }